import React from 'react';
import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import FilterModel from 'app/components/FilterModel';
import Dropdown from 'app/components/Dropdown';
import { campaignTableHeader } from 'app/constants/table-header-constants';
import useGamificationCampaigns from './useGamificationCampaigns';

// These values are sent to the server's status filter unchanged (they are
// not display labels) and must stay in step with the backend's derived-status
// vocabulary (GamificationCampaignService.deriveCampaignStatus, D-09/D-10,
// 09-CONTEXT.md): DEACTIVATED, ENDED, DRAFT, SCHEDULED, ACTIVE. DRAFT is an
// addition to the previous four, not a replacement -- the four existing
// options keep exactly the meaning admins already know.
const STATUS_OPTIONS = [
  { label: 'Scheduled', value: 'SCHEDULED' },
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Ended', value: 'ENDED' },
  { label: 'Deactivated', value: 'DEACTIVATED' },
  { label: 'Draft', value: 'DRAFT' },
];

const GamificationCampaigns = () => {
  const {
    filteredData,
    fetchCampaignData,
    isdeleteFiltering,
    isFiltering,
    appliedFilters,
    pageLoading,
    currentPage,
    dataPerPage,
    pageCount,
    totalNumber,
    handleView,
    handleDeactivate,
    sectionObj,
    isFilterOpen,
    setIsFilterOpen,
    values,
    setValues,
    handleSubmit,
    handleFilterCancel,
    resetfilter,
  } = useGamificationCampaigns();

  return (
    <>
      <div className='cms-content__container'>
        <PaginatedTable
          sectionObj={sectionObj}
          columns={campaignTableHeader}
          data={filteredData}
          fulldata={filteredData}
          currentPage={currentPage}
          dataPerPage={dataPerPage}
          totalNumber={totalNumber}
          pageCount={pageCount}
          handleEdit={handleView}
          handleDelete={handleDeactivate}
          pageLoading={pageLoading}
          fetchData={fetchCampaignData}
          isdeleteFiltering={isdeleteFiltering}
          isFiltering={isFiltering}
          values={appliedFilters}
        />

        {isFilterOpen && (
          <FilterModel
            isFilterOpen={isFilterOpen}
            setIsFilterOpen={setIsFilterOpen}
            onSubmit={handleSubmit}
            onCancel={handleFilterCancel}
            values={values}
            setValues={setValues}
            resetfilter={resetfilter}
          >
            <div className='offcanvas-item'>
              <Dropdown
                id='status'
                label='Status'
                name='status'
                options={STATUS_OPTIONS}
                placeholder='All'
                value={values.status}
                handleChange={(e) =>
                  setValues({ ...values, status: e.target.value })
                }
              />
            </div>
          </FilterModel>
        )}
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default GamificationCampaigns;
